import {
    validateAddressWithAvalara as validateAddressWithAvalaraApi,
    ValidateAddressWithAvalaraApiParameter,
} from "@eisinc/App/Services/AddressValidationWithAvalaraService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<ValidateAddressWithAvalaraApiParameter, any>;

export const DispatchBegin: HandlerType = props => {
    props.dispatch({
        type: "AvalaraValidation/SetIsLoading",
        isLoading: true,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await validateAddressWithAvalaraApi(props.apiParameter);
};

export const DispatchCompleted: HandlerType = props => {
    props.dispatch({
        type: "AvalaraValidation/SetIsLoading",
        isLoading: false,
    } as any);
};

export const chain = [DispatchBegin, PopulateApiParameter, SendDataToApi, DispatchCompleted];

const validateAddressWithAvalara = createHandlerChainRunner(chain, "ValidateAddressWithAvalara");
export default validateAddressWithAvalara;
